import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Tarima, Cliente } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TarimaService {

  url = environment.url + '/tarimas';

  constructor(private http: HttpClient) {}

  count() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/count?cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }

  getAll(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }&cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }

  getFull() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/full`, { headers }).pipe( map( data => data));
  }

  getByID(idTarima: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/id?tarima=${ idTarima }`, { headers }).pipe( map( data => data));
  }

  add(tarima: Tarima) {
    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    tarima.cliente = cliente;
    let body = JSON.stringify(tarima);

    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.post(`${ this.url }/add?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  update(tarima: Tarima) {
    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    tarima.cliente = cliente;
    let body = JSON.stringify(tarima);

    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.put(`${ this.url }/update?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  delete(tarima: Tarima) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    tarima.cliente = cliente;

    return this.http.delete(`${ this.url }/delete/?idCliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }&cliente=${ tarima.cliente.id }&tarima=${ tarima.id }`, { headers }).pipe( map( data => data));
  }
}
